import swal from 'sweetalert';

export function errorAlert(action = 'An error occured performing this action', options = {}) {
    if(!action) {
        action = '';
    }
    const email = window.help_email ? window.help_email : 'ben@cheerfully.com';
    const defaultOptions = {
        title: 'Something Went Wrong',
        text: `${action}${action.endsWith('.') ? '' : '.'} If this keeps happening contact us at ${email}`,
        icon: 'error'
    };
    return swal({...defaultOptions, ...options});
}

export function successAlert(text = '', options = {}) {
    const defaultOptions = {
        title: 'Success!',
        icon: 'success',
        text
    };
    return swal({...defaultOptions, ...options});
}

export function warningAlert(text = '', options = {}) {
    const defaultOptions = {
        title: 'Warning',
        icon: 'warning',
        text
    };
    return swal({...defaultOptions, ...options});
}
